import moment from "moment-timezone";

export const TIMEZONE_OPTIONS = moment.tz.names().map((tz) => ({
  value: tz,
  label: `${tz} (GMT${moment.tz(tz).format("Z")})`,
}));
